import React, { useCallback, useContext, useState } from 'react';
import { Box, BoxProps } from '@mui/material';
import { UiContext } from 'shared/lib/contexts/uiContext';
import { mainGridColumns } from 'shared/lib/utils/globalUtils';
import { useBooleanScreens } from 'shared/hooks/useBooleanScreens';

export default function UploadGrid({
  isAutoHeight = true,
  ...props
}: BoxProps & { isAutoHeight?: boolean }) {
  const {
    spacings: { sp },
  } = useContext(UiContext);

  const { isLessLaptop } = useBooleanScreens();

  const [height, setImageH] = useState(0);

  const calcHeight = useCallback(
    (el: null | HTMLDivElement) => {
      if (el) {
        if (isLessLaptop) {
          setImageH(window.innerHeight / 2);
        } else {
          setImageH(el.getBoundingClientRect().height);
        }
      }
    },
    [isLessLaptop]
  );

  return (
    <Box
      ref={calcHeight}
      {...props}
      sx={{
        display: isLessLaptop ? 'flex' : 'grid',
        flexDirection: isLessLaptop ? 'column' : 'row',
        flexGrow: 1,
        width: 1,
        gridTemplateColumns: mainGridColumns,
        rowGap: sp.s80 * 2,
        columnGap: sp.s80,
        minHeight: 400,

        gridTemplateRows: isAutoHeight ? 'auto' : `${height}px`,
        ...props.sx,
      }}
    ></Box>
  );
}
